import { render, staticRenderFns } from "./JFileInputImage.vue?vue&type=template&id=293514da"
import script from "./JFileInputImage.vue?vue&type=script&lang=ts"
export * from "./JFileInputImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports